<customer-site *ngIf="site"></customer-site>
<customer-site-not-found *ngIf="siteNotFound"></customer-site-not-found>
<ng-container *ngIf="site">
  <customer-script *ngFor="let script of site.scripts">{{ script.source }}</customer-script>
</ng-container>
